<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-btn
          text
          @click="$router.go(-1)"
          class="mb-4"
        >
          <v-icon left>mdi-arrow-left</v-icon>
          Zurück
        </v-btn>
        <v-card v-if="organization">
          <v-card-title>
            Organisation anzeigen: {{ organization.name }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="9">
                <v-text-field
                  v-model="organization.name"
                  label="Name"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="organization.kro_nr"
                  label="KRO"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="organization.external_id"
                  label="Externe ID"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="valid_from"
                  label="Gültig von"
                  type="date"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="valid_before"
                  label="Gültig bis"
                  type="date"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-for="donationReceiptConfiguration in donationReceiptConfigurations" :key="donationReceiptConfiguration.id">
              <v-col cols="12">
                <v-card class="mt-4">
                  <v-card-subtitle class="pb-2">
                    <strong>ID:</strong> {{ donationReceiptConfiguration.id }} |
                    <strong>Konfigurierte Vorlagen:</strong> {{ donationReceiptConfiguration.template_files.length }} |
                    <strong>Verwendungsschlüssel:</strong> <span v-if="donationReceiptConfiguration.special_purpose">{{ donationReceiptConfiguration.special_purpose }}</span><span v-else>&mdash;</span>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="4">
                        <div class="text-caption mb-1">Adresse</div>
                        <div v-for="(line, index) in donationReceiptConfiguration.data.address" :key="index">
                          {{ line }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          :value="donationReceiptConfiguration.data.purpose_name"
                          label="Verwendungszweck"
                          readonly
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          :value="donationReceiptConfiguration.data.signing_location"
                          label="Unterschriftsort"
                          readonly
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-alert v-else-if="error" type="error">
          {{ error }}
        </v-alert>
        <v-progress-linear v-else indeterminate color="primary"></v-progress-linear>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// FIXME AI
import { GET_TENANTS } from '@/modules/kirchgeld/store/kirchgeld/action-types'
import moment from 'moment'

export default {
  name: 'OrganizationDetail',
  data () {
    return {
      organization: null,
      error: null,
      valid_from: '',
      valid_before: '',
      donationReceiptConfigurations: [],
    }
  },
  computed: {
    organizationId () {
      return this.$route.params['organization-id'] || null
    }
  },
  methods: {
    async fetchOrganization () {
      try {
        this.organization = null
        this.donationReceiptConfigurations = []

        await this.$store.dispatch('kirchgeld/' + GET_TENANTS)
        const tenantUrl = this.$store.state.kirchgeld.tenant.url
        const orgId = this.organizationId
        const response = await this.$store.getters['kirchgeld/api'].get(`${tenantUrl}organization/${orgId}/`)
        this.organization = response.data
        this.valid_from = this.organization.valid_from ? moment(this.organization.valid_from).format('YYYY-MM-DD') : ''
        this.valid_before = this.organization.valid_before ? moment(this.organization.valid_before).format('YYYY-MM-DD') : ''

        const donationReceiptConfigurationResponse = await this.$store.getters['kirchgeld/api'].get(`${tenantUrl}donation_receipt_configuration/?limit=1000`)
        this.donationReceiptConfigurations = (donationReceiptConfigurationResponse.data?.results || []).filter(
          item => item.organization === this.organization.url
        )
      } catch (e) {
        this.error = 'Organisation konnte nicht geladen werden.'
        // eslint-disable-next-line
        console.error(e)
      }
    }
  },
  watch: {
    organizationId: {
      immediate: true,
      async handler (newVal) {
        if (newVal) {
          await this.fetchOrganization()
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
